import { Component, inject } from '@angular/core';
import { ResponsiveService } from 'src/app/services/responsive.service';
import { HudComponent } from '../hud/hud.component';
import { HomeVideoComponent } from '../home-video/home-video.component';
import { AboutVideoComponent } from '../about-video/about-video.component';
import { WeaponParallaxComponent } from '../weapon-parallax/weapon-parallax.component';
import { MagicElementsComponent } from '../magic-elements/magic-elements.component';
import { SocialOrderComponent } from '../social-order/social-order.component';
import { GameplayActivitiesComponent } from '../gameplay-activities/gameplay-activities.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-front-page',
    templateUrl: './front-page.component.html',
    styleUrls: ['./front-page.component.css'],
    imports: [HudComponent, HomeVideoComponent, AboutVideoComponent, WeaponParallaxComponent, MagicElementsComponent, SocialOrderComponent, GameplayActivitiesComponent, FooterComponent]
})
export class FrontPageComponent {
  responsiveService = inject(ResponsiveService);
}
